import { render, staticRenderFns } from "./TagsPicker.vue?vue&type=template&id=66f2c7fc&lang=pug"
import script from "./TagsPicker.vue?vue&type=script&lang=js"
export * from "./TagsPicker.vue?vue&type=script&lang=js"
import style0 from "./TagsPicker.vue?vue&type=style&index=0&id=66f2c7fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports